import { render, staticRenderFns } from "./ChatBaloon.vue?vue&type=template&id=2ccc300c&scoped=true&"
import script from "./ChatBaloon.vue?vue&type=script&lang=js&"
export * from "./ChatBaloon.vue?vue&type=script&lang=js&"
import style0 from "./ChatBaloon.vue?vue&type=style&index=0&id=2ccc300c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccc300c",
  null
  
)

export default component.exports